import React, { useEffect, useState } from "react";
import { useAppLibs } from "../ContextProvider/AppLib_Provider";
import TicketCard from "../components/Tickets/TicketCard";
import { CreateButton } from "../utils/Buttons";

import Icon from "../utils/Icons";
import Drawer from "../components/Drawer";
import TicketView from "../components/Tickets/TicketView";
import CreateTicket from "../components/Tickets/CreateTicket";
import LoadingComp from "../components/LoadingComp";
import TicketGuideline from "../components/Tickets/TicketGuideline";

const TicketsModule = () => {
  const { Tickets } = useAppLibs();
  const [renderTicketsCard, setRenderTciketsCard] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [drawerState, setDrawerState] = useState({
    isOpen: false,
    Component: null,
    componentProps: {},
  });

  const openDrawer = (Component, componentProps = {}) => {
    setDrawerState({
      isOpen: true,
      Component,
      componentProps,
    });
  };

  const closeDrawer = () => {
    setDrawerState({ isOpen: false, Component: null, componentProps: {} });
  };

  const OpenTicketView = (item, index) => {
    openDrawer(TicketView, {
      item,
      index,
      setTickets,
      onClose: closeDrawer,
    });
  };

  const fetchTickets = async () => {
    const result = await Tickets.getTickets();
    if (result.success) {
      setTickets(result.data);
      setRenderTciketsCard(true);
      setError("");
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  const OpenCreateTicket = () => {
    openDrawer(CreateTicket, {
      width: "200px",
      setTickets,
      onClose: closeDrawer,
    });
  };

  const OpenTicketGuideline = () => {
    openDrawer(TicketGuideline, {
      width: "200px",
      onClose: closeDrawer,
    });
  };

  const ReloadTickets = (e) => {
    e.preventDefault();
    setLoading(true);
    fetchTickets();
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  // return (
  //   <div className="shadow-none p-4 space-y-4 overflow-y-auto h-[calc(100vh-65px)]">
  //     <LoadingComp
  //       message={
  //         "System Maintenance in Progress \n We’re currently performing scheduled maintenance. Please bear with us — we’ll be back shortly. Thank you for your patience."
  //       }
  //     />
  //   </div>
  // );

  return (
    <div className="shadow-none p-4 space-y-4 overflow-y-auto h-[calc(100vh-65px)]">
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-x-2 items-center">
          <button onClick={ReloadTickets} disabled={loading}>
            <Icon.reload className="text-blue-600 cursor-pointer" />
          </button>
        </div>
        <div className="flex gap-2">
          <button
            onClick={OpenTicketGuideline}
            className="px-3 py-1 flex justify-center items-center gap-1  cursor-pointer tracking-[.1em] uppercase border border-orange-700 rounded-lg text-orange-700 hover:text-orange-800 hover:border-orange-800 hover:shadow-lg"
          >
            Guideline
          </button>

          <CreateButton onClick={OpenCreateTicket} />
        </div>
      </div>

      {loading && (
        <div className="w-full flex justify-center">
          <span className="loading loading-spinner loading-lg text-primary"></span>
        </div>
      )}

      {error && (
        <div className="alert alert-error">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-current shrink-0 h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>{error}</span>
        </div>
      )}

      <div
        className={`w-[100%] transition-transform duration-700 ease-in-out transform ${
          renderTicketsCard
            ? "translate-x-0 opacity-100"
            : "translate-x-[-100%] opacity-0"
        } `}
        key="TicketsCardContainer"
      >
        <div className="grid gap-3">
          {tickets.map((ticket, i) => (
            <TicketCard
              key={ticket._id}
              ticket={ticket}
              index={i}
              onClick={() => OpenTicketView(ticket, i)}
            />
          ))}
        </div>
      </div>

      <Drawer props={{ ...drawerState, closeFn: closeDrawer }} />
    </div>
  );
};

export default TicketsModule;
